import React, { useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import { triggerNotification } from '../../../helpers/notification';
import StoreSettingsView from './StoreSettingsView';
import StoreTaxesViews from './StoreTaxesViews';
import StoreAdminViews from './StoreAdminViews';

const StoreSettingsViews = () => {
  const fetchedPkEcomStore = useRef(null);
  const { state: authState } = useContext(AuthContext);
  const { state, fetchStore } = useContext(StoreContext);

  const loading = !fetchedPkEcomStore.current || state.ecomStore.loading;
  const ecomStore =
    fetchedPkEcomStore.current?.toString() ===
    state.ecomStore.value?.pkEcomStore.toString()
      ? state.ecomStore.value
      : null;

  useEffect(() => {
    if (
      authState.pkEcomStore &&
      fetchedPkEcomStore.current !== authState.pkEcomStore
    ) {
      fetchStore(authState.pkEcomStore, null, (e) => triggerNotification(e));
      fetchedPkEcomStore.current = authState.pkEcomStore;
    }
  }, [authState.pkEcomStore]);

  return (
    <Routes>
      <Route
        element={<StoreTaxesViews ecomStore={ecomStore} loading={loading} />}
        path="/taxes/*"
      />
      <Route
        element={<StoreAdminViews ecomStore={ecomStore} loading={loading} />}
        path="/admins/*"
      />
      <Route
        element={<StoreSettingsView ecomStore={ecomStore} loading={loading} />}
        path="/"
      />
      <Route element={<Navigate replace to="/merchant/settings" />} path="*" />
    </Routes>
  );
};

export default StoreSettingsViews;
